import { render } from "./SettingsCosyVoice2.vue?vue&type=template&id=3d60838c&scoped=true"
import script from "./SettingsCosyVoice2.vue?vue&type=script&lang=js"
export * from "./SettingsCosyVoice2.vue?vue&type=script&lang=js"

import "./SettingsCosyVoice2.vue?vue&type=style&index=0&id=3d60838c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d60838c"]])

export default __exports__